// ===== themeAssets.ts =====


import {
  riskCodeToIcon,
  riskCodeToIconIngos,
} from '@components/widgets/myHealth/risksPage/risksSection/constants';

export type ThemeName = 'soglasie' | 'ingosstrakh' | 'reso';


export type ThemeAssetToken =
  | 'icon-burger'
  | 'icon-header-logo'
  | 'algorithmImage'
  | 'introImage'
  | 'introHomeImage'
  | 'reasons-1'
  | 'reasons-2'
  | 'reasons-3'
  | 'reasons-4'
  | 'reasons-5'
  | 'reasons-6'
  | 'tg'
  | 'pencil'
  | 'trash'
  | 'trashActive'
  | 'icon-mail'
  | 'icon-risks'
  | 'icon-warn'
  | 'icon-percent'
  | 'icon-success'
  | 'icon-doc'
  | 'icon-complete-passed'
  | 'icon-arrow-passed'
  | 'icon-loader'
  | 'avatarProfile'
  | 'avatarButton'
  | 'aboutHome'
  | 'possibilitiesImg'
  | 'slide1'
  | 'slide2'
  | 'slide3'
  | 'slide4'
  | 'imgReasonsIngos'
  | 'introMob'
  | 'photo-risk-logo1'
  | 'photo-risk-logo2'
  | 'photo-risk-logo3'
  | 'srcLogoLap'
  | 'manImage'
  | 'girlImage'
  | 'photo-training'
  | 'eat1'
  | 'eat2'
  | 'eat3'
  | 'icon-25'
  | 'icon-50'
  | 'icon-75'
  | 'icon-100'
  | 'contacts-left'
  | 'contacts-right'
  | 'checkupLeft'
  | 'checkupRight'
  | 'checkupLeftMobile'
  | 'checkupRightMobile'
  | 'phone'
  | 'phoneLink'
  | 'mail'
  | 'mailLink'
  | 'faviconIco'
  | 'faviconSvg'
  | 'appleTouchIcon'
  | 'maskIcon'
  | 'mailIcon'
  | 'brandText'
  | 'doneReset'
  | 'man'
  | 'girl'
  | 'colorLoader'
  | 'icon-cross'
  | 'checkUpTitle'
  | 'iconDownload'
  | 'iconDownloadHover'

/**
 * Partial: не обязательно указывать все ключи.
 * ThemeAssetToken как используется в компоненте
 * В самом компоненте так же указывается дефолтное значение
 * Указывается ключ темы и путь/имя/переменная
 * можно добавлять кастомные функции определения того или иного изображения/иконки и тд
 */
export type ThemeAssetsMap = Partial<Record<ThemeAssetToken, string>>;


import ingosA from '@assets/img/imageIntro-ingos.png'
import intro from '@assets/img/intro.png';
import introHome from '@assets/img/imageHome.png';
import avatarPlaceholder from '@assets/img/avatarProfile.png';
import avatarIngos from '@assets/img/avataringos.png';
import img from '@assets/img/profile-avatar.jpg'
import ingosAbout from '@assets/img/ingosAbout1.png';
import aboutImg from '@assets/img/mockup.png';
import phoneIngos from '@assets/img/phone-ingos.png';
import possibilitiesImg from '@assets/img/possibilitiesPhone.png';

import slide1 from '@assets/img/iphone1.png';
import slide2 from '@assets/img/iphone2.png';
import slide3 from '@assets/img/iphone3.png';
import slide4 from '@assets/img/iphone4.png';
import slide1ingos from '@assets/img/slide1ingos.png';
import slide2ingos from '@assets/img/slide2ingos.png';
import slide3ingos from '@assets/img/slide3ingos.png';
import slide4ingos from '@assets/img/ingosSlide4.png';

import imgReasonsIngos from '@assets/img/imgReasonsIngos.png';
import womanWithVegetables from '@assets/img/orange-wmn.png';

import introMobIngos from '@assets/img/introMobIngos.png';
import womanPosignWithBroccoli from '@assets/img/woman-posing-with-broccoli.png';
import photoRisk1 from '@assets/img/1.png';
import photoRisk2 from '@assets/img/2.png';
import photoRisk3 from '@assets/img/3.png';
import img1 from '@assets/img/neural-network-card-image1.png'
import img2 from '@assets/img/neural-network-card-image2.png'
import img3 from '@assets/img/neural-network-card-image3.png'
import img4 from '@assets/img/test-result-img.png';
import imglapingos from '@assets/img/imglapingos.png';
import manImage from 'assets/img/man-eating-salad.png';
import manIngos from 'assets/img/maningos.png';
import girlImage from '@assets/img/123.png'
import girlIngos from '@assets/img/girlIngos.png';
import photoTraining from '@assets/img/program-image2.png';
import trainingIngos from '@assets/img/trainingIngos.png';
import trainReso from '@assets/img/trainreso.png';
import eat1 from '@assets/img/program-nutrition-image1.png';
import eat2 from '@assets/img/program-nutrition-image2.png';
import eat3 from '@assets/img/program-nutrition-image3.png';
import eat1ingos from '@assets/img/eatingos1.png';
import eat2ingos from '@assets/img/eatingos2.png';
import eat3ingos from '@assets/img/eatingos3.png';
import resoNutritionEat2 from '@assets/img/food1.png';
import resoNutritionEat3 from '@assets/img/food2.png';
import stats25 from '@assets/img/25-stats.svg';
import stats50 from '@assets/img/50-stats.svg';
import stats75 from '@assets/img/75-stats.svg';
import stats100 from '@assets/img/100-stats.svg';
import stats25ingos from '@assets/img/svg-3-ingos.svg';
import stats50ingos from '@assets/img/svg-4-ingos.svg';
import stats75ingos from '@assets/img/svg-1-ingos.svg';
import stats100ingos from '@assets/img/svg-2-ingos.svg';
import contactsLeft from '@assets/img/leftContact.png';
import contactsRight from '@assets/img/rightContact.png';
import leftIngos from '@assets/img/leftIngos.png';
import rightIngos from '@assets/img/rightIngos.png';

import checkupLeft from '@assets/img/test-intro-image1.jpg';
import checkupRight from '@assets/img/test-intro-image2.jpg';
import checkupLeftIngos from '@assets/img/checkIngos.png';
import checkupRightIngos from '@assets/img/checkIngos2.png';
import ingosMail from '@assets/img/ingosMail.png';
import doneIngos from '@assets/img/ingosDone.png';
import ingosMan from '@assets/img/ingosMan.png';
import ingosGirl from '@assets/img/ingosGirl.png';
import T from '@data/text/themeAssetsTexts.json';
import resoMask from '@assets/img/resoMask.png';
import imageIntroReso from '@assets/img/introReso.png';
import homeReso from '@assets/img/homeR.png';
import homeReso1 from '@assets/img/homeR1.png';
import algorithmDefault from '@assets/img/algorithm.png';
import phoneReso from '@assets/img/resophonelarge.png';
import phoneReso1 from '@assets/img/resophone1.png';
import phoneReso2 from '@assets/img/resophone2.png';
import phoneReso3 from '@assets/img/resophone3.png';
import phoneReso4 from '@assets/img/resophone4.png';
import resoLeft from '@assets/img/resoLeft.png';
import resoRight from '@assets/img/resoRight.png';
import avatarReso from '@assets/img/avatarReso.png';
import avatarMainReso from '@assets/img/avatarMainReso.png';
import forgotPasswordSentReso from '../assets/svg/forgot-password-sent-reso.svg';
import resetPasswordSentReso from '../assets/svg/reset-password-sent-reso.svg';
import healthResoLeft from '@assets/img/healthResoLeft.png';
import healthResoRight from '@assets/img/healthResoRight.png';
import healthResoLeftMobile from '@assets/img/healthResoLeftMobile.png';
import healthResoRightMobile from '@assets/img/healthResoRightMobile.png';
import laptopReso from '@assets/img/laptopReso.png';
import re1 from '@assets/img/re1.png';
import re2 from '@assets/img/re2.png';

export const THEME_ASSETS: Record<ThemeName, ThemeAssetsMap> = {
  soglasie: {
    // Логотипы


    // Фото/баннеры
    'introImage': intro,
    'algorithmImage': algorithmDefault,
    'introHomeImage': introHome,
    'avatarProfile': avatarPlaceholder,
    'avatarButton': img,
    'aboutHome': aboutImg,
    'possibilitiesImg': possibilitiesImg,
    'slide1': slide1,
    'slide2': slide2,
    'slide3': slide3,
    'slide4': slide4,
    'imgReasonsIngos': womanWithVegetables,
    'introMob': womanPosignWithBroccoli,
    'photo-risk-logo1': img1,
    'photo-risk-logo2': img2,
    'photo-risk-logo3': img3,
    'srcLogoLap': img4,
    'manImage': manImage,
    'girlImage': girlImage,
    'photo-training': photoTraining,
    'eat1': eat1,
    'eat2': eat2,
    'eat3': eat3,
    'icon-25': stats25,
    'icon-50': stats50,
    'icon-75': stats75,
    'icon-100': stats100,
    'contacts-left': contactsLeft,
    'contacts-right': contactsRight,
    'checkupLeft': checkupLeft,
    'checkupRight': checkupRight,
    'checkupLeftMobile': checkupLeft,
    'checkupRightMobile': checkupRight,


    // Иконки
    'icon-header-logo': 'icon-logo-soglasie', //лого в хедере
    'icon-burger': 'soglasieBurger', //бургер в мобилке
    'reasons-1': 'home1',
    'reasons-2': 'home2',
    'reasons-3': 'home3',
    'reasons-4': 'home4',
    'reasons-5': 'home5',
    'reasons-6': 'home6',
    'tg': 'telegramSogl',
    'pencil': '',
    'trash': 'trash',
    'trashActive': 'trash-active',
    'icon-mail': 'icon-mail',
    'icon-warn': 'icon-warning',
    'icon-percent': 'icon-percent',
    'icon-success': 'icon-success',
    'icon-doc': 'icon-doc',
    'icon-complete-passed': 'icon-complete-passed-soglasie',
    'icon-arrow-passed': 'icon-arrow-passed',
    'icon-loader': 'icon-loader-rotate',




    // текст
    'phone': T.byTheme.soglasie.phone,
    'brandText': T.byTheme.soglasie.brandText,
    'phoneLink': T.byTheme.soglasie.phoneLink,
    'mail': T.byTheme.soglasie.mail,
    'mailLink': T.byTheme.soglasie.mailLink,
    'checkUpTitle': T.byTheme.soglasie.checkUpTitle,

  },

  ingosstrakh: {

    // Логотипы
    // Фото/баннеры
    'introImage': ingosA,
    'algorithmImage': algorithmDefault,
    'introHomeImage': ingosA,
    'avatarProfile': avatarIngos,
    'avatarButton': avatarIngos,
    'aboutHome': ingosAbout,
    'possibilitiesImg': phoneIngos,
    'slide1': slide1ingos,
    'slide2': slide2ingos,
    'slide3': slide3ingos,
    'slide4': slide4ingos,
    'imgReasonsIngos': imgReasonsIngos,
    'introMob': introMobIngos,
    'photo-risk-logo1': photoRisk1,
    'photo-risk-logo2': photoRisk2,
    'photo-risk-logo3': photoRisk3,
    'srcLogoLap': imglapingos,
    'manImage': manIngos,
    'girlImage': girlIngos,
    'photo-training': trainingIngos,
    'eat1': eat1ingos,
    'eat2': eat2ingos,
    'eat3': eat3ingos,
    'icon-25': stats25ingos,
    'icon-50': stats50ingos,
    'icon-75': stats75ingos,
    'icon-100': stats100ingos,
    'contacts-left': leftIngos,
    'contacts-right': rightIngos,
    'checkupLeft': checkupLeftIngos,
    'checkupRight': checkupRightIngos,
    'checkupLeftMobile': checkupLeftIngos,
    'checkupRightMobile': checkupRightIngos,
    'mailIcon': ingosMail,
    'doneReset': doneIngos,
    'man': ingosMan,
    'girl': ingosGirl,
    'colorLoader': '#33C9FF',

    // Иконки
    'icon-header-logo': 'ingosHeaderLogo',
    'icon-burger': 'ingosBurger',
    'reasons-1': 'home1',
    'reasons-2': 'home2',
    'reasons-3': 'home3',
    'reasons-4': 'home4',
    'reasons-5': 'home5',
    'reasons-6': 'home6',
    'tg': 'tgingos',
    'pencil': 'ingosPencil',
    'trash': 'trashIngos',
    'trashActive': 'trashIngosHover',
    'icon-mail': 'icon-mail-ingos',
    'icon-warn': 'icon-warning-ingos',
    'icon-percent': 'icon-percent-ingos',
    'icon-success': 'icon-success-ingos',
    'icon-doc': 'icon-doc-ingos',
    'icon-complete-passed': 'icon-complete-passed-ingos',
    'icon-arrow-passed': 'icon-arrow-passed-ingos',
    'icon-loader': 'icon-loader-rotate-ingos',
    'icon-cross': 'icon-cross-ingos',
    'iconDownload': 'iconDownloadIngos',
    'iconDownloadHover': 'iconDownloadHoverIngos',


    // текст
    'phone': T.byTheme.ingosstrakh.phone,
    'brandText': T.byTheme.ingosstrakh.brandText,
    'phoneLink': T.byTheme.ingosstrakh.phoneLink,
    'mail': T.byTheme.ingosstrakh.mail,
    'mailLink': T.byTheme.ingosstrakh.mailLink,
    'checkUpTitle': T.byTheme.ingosstrakh.checkUpTitle
  },

  reso: {
    'introImage': imageIntroReso,
    'algorithmImage': homeReso1,
    'introHomeImage': imageIntroReso,
    'avatarProfile': avatarMainReso,
    'avatarButton': avatarReso,
    'aboutHome': homeReso,
    'possibilitiesImg': phoneReso,
    'slide1': phoneReso1,
    'slide2': phoneReso2,
    'slide3': phoneReso3,
    'slide4': phoneReso4,
    'imgReasonsIngos': imgReasonsIngos,
    'introMob': resoMask,
    'photo-risk-logo1': re1,
    'photo-risk-logo2': photoRisk2,
    'photo-risk-logo3': re2,
    'srcLogoLap': laptopReso,
    'manImage': manIngos,
    'girlImage': girlIngos,
    'photo-training': trainReso,
    'eat1': eat1ingos,
    'eat2': resoNutritionEat2,
    'eat3': resoNutritionEat3,
    'icon-25': stats25ingos,
    'icon-50': stats50ingos,
    'icon-75': stats75ingos,
    'icon-100': stats100ingos,
    'contacts-left': resoLeft,
    'contacts-right': resoRight,
    'checkupLeft': healthResoRight,
    'checkupRight': healthResoLeft,
    'checkupLeftMobile': healthResoRightMobile,
    'checkupRightMobile': healthResoLeftMobile,
    'mailIcon': forgotPasswordSentReso,
    'doneReset': resetPasswordSentReso,
    'man': ingosMan,
    'girl': ingosGirl,
    'colorLoader': '#009639',
    'icon-header-logo': 'resoLogo',
    'icon-burger': 'burger-reso',
    'reasons-1': 'home1',
    'reasons-2': 'home2',
    'reasons-3': 'home3',
    'reasons-4': 'home4',
    'reasons-5': 'home5',
    'reasons-6': 'home6',
    'tg': 'tgingos',
    'pencil': 'ingosPencil',
    'trash': 'trashReso',
    'trashActive': 'trashReso',
    'icon-mail': 'icon-mail-reso',
    'icon-warn': 'icon-warning-reso',
    'icon-percent': 'icon-percent-ingos',
    'icon-success': 'icon-success-ingos',
    'icon-doc': 'icon-doc-ingos',
    'icon-complete-passed': 'icon-complete-passed-reso',
    'icon-arrow-passed': 'icon-arrow-passed-reso',
    'icon-loader': 'icon-loader-rotate-reso',
    'icon-cross': 'icon-cross-ingos',
    'iconDownload': 'iconDownloadReso',
    'iconDownloadHover': 'iconDownloadHoverReso',
    'phone': T.byTheme.reso.phone,
    'brandText': T.byTheme.reso.brandText,
    'phoneLink': T.byTheme.reso.phoneLink,
    'mail': T.byTheme.reso.mail,
    'mailLink': T.byTheme.reso.mailLink,
    'checkUpTitle': T.byTheme.reso.checkUpTitle
  },
};

/**
 * - если темы нет -> вернёт fallback (или undefined)
 * - если токена нет для темы -> fallback (или undefined)
 */
export function getThemeAsset(
  theme: ThemeName | null | undefined,
  token: ThemeAssetToken,
  fallback?: string,
): string | undefined {
  if (!theme) return fallback;

  let themeForAsset = theme;
  if (
    theme === 'ingosstrakh' &&
    typeof document !== 'undefined' &&
    document.documentElement.dataset.company === 'reso'
  ) {
    themeForAsset = 'reso';
  }

  const conf = THEME_ASSETS[themeForAsset];
  if (!conf) return fallback;

  const value = conf[token];
  if (!value) return fallback;

  return value;
}

export function getCurrentThemeFromDom(): ThemeName | null {
  if (typeof document === 'undefined') return null;
  const rawTheme = document.documentElement.dataset.company;
  if (!rawTheme) return null;
  // Keep legacy ingos feature branches compatible for reso.
  if (rawTheme === 'reso') return 'ingosstrakh';
  return rawTheme as ThemeName;
}

export function getCurrentThemeAsset(
  token: ThemeAssetToken,
  fallback?: string,
): string | undefined {
  const theme = getCurrentThemeFromDom();
  return getThemeAsset(theme, token, fallback);
}


export function normalizeTheme(value: string | null | undefined): ThemeName | null {
  if (!value) return null;
  return (Object.keys(THEME_ASSETS) as ThemeName[]).includes(value as ThemeName)
    ? (value as ThemeName)
    : null;
}


export function getRiskIconsByTheme(theme: ThemeName | null): Record<string, string> {
  switch (theme) {
    case 'soglasie':
      return riskCodeToIcon;
    case 'ingosstrakh':
    case 'reso':
      return riskCodeToIconIngos;
    default:
      return riskCodeToIcon;
  }
}